import React, { useState } from "react";
import { Link } from "react-router-dom";
import Shoes from "../../shoes.json";
import "../../Modal.css";
export default function ProductItems() {
    const [modal, setModal] = useState(false);

    const toggleModal = () => {
      setModal(!modal);
    };
  
    if (modal) {
      document.body.classList.add("active-modal");
    } else {
      document.body.classList.remove("active-modal");
    }
  
  return (
    <>
    {modal && (
        <div className="modal">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modal-content">
            <h2>Ordering form will be added soon!</h2>
            <br/>
            <button className=" order" onClick={toggleModal}>
              CLOSE
            </button>
          </div>
        </div>
      )}
      <div className="main-div">
        {Object.keys(Shoes).map((key) => {
          const shoe = Shoes[key];
          return (
            <div className="products-div" key={key}>
              <Link className="links" to={`/products/${key}`}>
                <p>
                  {" "}
                  <img
                    className="product_image"
                    src={`${shoe.img}`}
                    alt={shoe.name}
                  />
                </p>
              </Link>

              <div className="texts">
                <h1 className="name">{shoe.name}</h1>
                <p><span>Full Price: </span>{shoe.price},000 IQD</p>
                <p>
                  <span>Discount Amount:</span> {
                  shoe.price>120?<span>80%</span>:
                  shoe.price>100?<span>70%</span>:
                  shoe.price>80?<span>60%</span>:
                  shoe.price>60?<span>50%</span>:
                  shoe.price>40?<span>40%</span>:
                  <span>30%</span>}
                </p>
                <div>
                <span>Discounted Price:</span>
                  
                 { shoe.price>120?Math.floor(shoe.price*0.2):
                 shoe.price>100?Math.floor(shoe.price*0.3):
                 shoe.price>80?Math.floor(shoe.price*0.4):
                 shoe.price>60?Math.floor(shoe.price*0.5):
                 shoe.price>40?Math.floor(shoe.price*0.6):
                 Math.floor(shoe.price*0.7)}
                   ,000 IQD
                  
                </div>
                <p>
                  <span>Brand:</span> {shoe.brand}
                </p>
                <p>
                  <span>Gender:</span> {shoe.gender}
                </p>
                <p>
                  <span>Category:</span> {shoe.category}
                </p>
                <p>
                  <span>Size:</span> {`${"35,36,37,38,39,40"}`}
                </p>
              </div>
              <button onClick={toggleModal} className="order">
                           Order Now
            </button>              
          </div>
          );
        })}
      </div>
    </>
  );
}
